<template>
  <div>
    <input-with-validation type="number" :disabled="readOnly" step="any" :vid="randomVid" :field-label="$attrs.label" :rules="rules" :placeholder="placeholder" b-name="input" v-model="model"></input-with-validation>
  </div>
</template>

<script>
import InputWithValidation from "@/components/validation/InputWithValidation";
import ElementRendererMixin from "@/components/form_builder/ElementRendererMixin";
export default {
  name: "NumberElementRenderer",
  mixins: [ElementRendererMixin],
  components: {InputWithValidation},
  data() {
    return {
      fieldType: Number.name
    }
  }
}
</script>

<style scoped>

</style>
